import { createFileRoute, notFound } from '@tanstack/react-router'

import { DocumentLayout } from '@/app/document-layout'
import { DocumentNotFound } from '@/app/error-boundary'
import { fetchDocument } from '@/app/route-guards'
import { isApiError } from '@/lib/api/errors'

export const Route = createFileRoute('/_auth/documents/$docId')({
  beforeLoad: async ({ context, params }) => {
    try {
      await fetchDocument(context.queryClient, params.docId)
    } catch (e) {
      if (isApiError(e) && e.status === 404) throw notFound()
      throw e
    }
  },
  notFoundComponent: DocumentNotFound,
  component: DocumentRoute,
})

function DocumentRoute() {
  const { docId } = Route.useParams()
  return <DocumentLayout docId={docId} />
}
